import { HrPscOcc, HrPscComments } from "../../../../models";


export class PscOcc extends HrPscOcc {
  constructor(primaryOccTo: boolean = null) {
    super();
    this.pscId = 0;
    this.occId = 0;
    this.occDateFrom =null;
    this.occDateTo = null;
    this.occStatusFrom = null;
    this.occStatusTo = null;
    this.primaryOccFrom = null;
    this.primaryOccTo = primaryOccTo;
    this.jobTitleFrom = null;
    this.jobTitleTo = null;
    this.jobTitleToId = null;
    this.employmentTypeFrom = null;
    this.employmentTypeTo = null;
    this.employmentTypeToId = null;
    this.workSectionFrom = null;
    this.workSectionTo = null;
    this.workSectionToId = null;
  }

}

export class PscComments extends HrPscComments {
  constructor(pscId: number, user: any, comment?: string) {
    super();
    this.pscId = pscId;
    this.addedBy = user.fullName;
    this.comment = comment;
    this.commentDate = new Date();
  }

}
